import React, { useContext } from 'react';

const I18NextContext = React.createContext({ strings: str => str, lookupExists: str => str });

export const useI18Next = () => useContext(I18NextContext);

export default I18NextContext;
